import React, { FunctionComponent } from 'react'
import { get } from 'lodash'

import { Col } from '../../../../components/Table/next'
import OverviewReportTableContainer from '../Table'

import { useOverviewReportingLazyQuery } from '../../../../generated/types'
import accounting from 'accounting'
import { GenerateDetailReportLink } from '../../../../components/LinkRow/index'
import styles from '../Table/styles.module.css'
import classnames from 'classnames'

const OverviewReportContainer: FunctionComponent = () => {
  const [
    OverviewReportingResult,
    { data, loading, error, variables },
  ] = useOverviewReportingLazyQuery({
    fetchPolicy: 'no-cache',
    nextFetchPolicy: 'no-cache',
  })

  const [
    OverviewReportingExportResult,
    { data: exportData, loading: exportLoading, error: exportError },
  ] = useOverviewReportingLazyQuery({
    fetchPolicy: 'no-cache',
    nextFetchPolicy: 'no-cache',
  })

  const cols: Col[] = [
    {
      text: 'Vertical',
      field: 'verticalName',
      sortable: true,
      className: classnames(styles.fill, styles.center),
      render: row => (
        <GenerateDetailReportLink
          whereCriteria="verticalId"
          id={get(row, 'verticalId', '')}
          value={get(row, 'verticalName', '')}
          detailPath="/new/reports/vertical-summary"
          queryParams={[
            {
              startDate: formatDate(variables.start),
              endDate: formatDate(variables.end),
              dateRange: 'custom',
              verticalId: get(row, 'verticalId', ''),
            },
          ]}
        />
      ),
    },
    {
      text: 'Total Impressions',
      field: 'totalImpressions',
      sortable: false,
      render: row => accounting.formatNumber(get(row, 'totalImpressions', '')),
      className: styles.right,
    },
    {
      text: 'Viewable Impressions',
      field: 'viewableImpressions',
      sortable: false,
      render: row =>
        accounting.formatNumber(get(row, 'viewableImpressions', '')),
      className: styles.right,
    },
    {
      text: 'Product Clicks',
      field: 'productClicks',
      sortable: true,
      render: row => accounting.formatNumber(get(row, 'productClicks', '')),
      className: styles.right,
    },
    {
      text: 'Unique Clicks',
      field: 'uniqueClicks',
      sortable: true,
      render: row => accounting.formatNumber(get(row, 'uniqueClicks', '')),
      className: styles.right,
    },
    {
      text: 'Total Ctr',
      field: 'totalCTR',
      sortable: true,
      render: row => `${(get(row, 'totalCTR', '') * 100).toFixed(2)}%`,
      className: styles.right,
    },
    {
      text: 'Viewable Ctr',
      field: 'viewableCTR',
      sortable: true,
      render: row => `${(get(row, 'viewableCTR', '') * 100).toFixed(2)}%`,
      className: styles.right,
    },
    {
      text: 'Sales',
      field: 'sales',
      sortable: true,
      render: row => accounting.formatNumber(get(row, 'sales', '')),
      className: styles.right,
    },
    {
      text: 'Conversion Rate',
      field: 'conversionRate',
      sortable: true,
      render: row => `${(get(row, 'conversionRate', '') * 100).toFixed(2)}%`,
      className: styles.right,
    },
    {
      text: 'Commissions',
      field: 'commission',
      sortable: true,
      render: row => accounting.formatMoney(get(row, 'commission', ''), '$'),
      className: styles.right,
    },
    {
      text: 'EPC',
      field: 'epc',
      sortable: true,
      render: row => accounting.formatMoney(get(row, 'epc', ''), '$'),
      className: styles.right,
    },
  ]

  return (
    <OverviewReportTableContainer
      groupBy="page"
      cols={cols}
      footerPadding={2}
      getData={OverviewReportingResult}
      data={data}
      loading={loading}
      error={error}
      getExportData={OverviewReportingExportResult}
      exportData={exportData}
      exportLoading={exportLoading}
      exportError={exportError}
    />
  )
}

const formatDate = (dateStr: string): string => {
  const date = new Date(dateStr)
  date.setDate(date.getDate())
  return new Date(date.getTime()).toISOString().split('T')[0]
}

export default OverviewReportContainer
